export const capitalizeString = (str: string): string => {
  /*
  abc abc -> Abc abc
  */
  if (!str) return "";

  if (typeof str !== "string") return "";

  return `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
};

export const formatDateToString = (val: string | Date): string => {
  /*
  Date -> dd/mm/yyyy
  */
  if (!val || val === "0001-01-01T00:00:00Z") return "";

  const date = new Date(val);

  if (isNaN(date.getTime())) return "";

  const year = date.toLocaleString("default", { year: "numeric" });
  const month = date.toLocaleString("default", { month: "2-digit" });
  const day = date.toLocaleString("default", { day: "2-digit" });

  return `${day}/${month}/${year}`;
};

export const formatStringToDate = (val: string): Date => {
  /*
  dd/mm/yyyy -> Date
  */
  if (!val) return new Date();

  const arr = val.split("/").map((item) => Number(item));

  if (arr.length !== 3) return new Date();

  const date = new Date(arr[2], arr[1] - 1, arr[0]);

  return date;
};

export const formatNumber = (n: number): string => {
  /**
   * Format numbers:
   * 1–3 digits: "1", "99", "999"
   * 4–6 digits: space before last 3 digits, e.g. "6 234", "12 345", "999 999"
   * ≥7 digits: compact millions, e.g. "1M", "12.5M"
   */
  if (typeof n !== "number" || !Number.isFinite(n)) return "";

  const sign = n < 0 ? "-" : "";
  const abs = Math.abs(Math.trunc(n));

  // 1–3 digits
  if (abs < 1000) {
    return sign + String(abs);
  }

  // 4–6 digits
  if (abs < 1_000_000) {
    const s = String(abs);

    return sign + s.slice(0, -3) + " " + s.slice(-3);
  }

  // ≥7 digits
  const m = Math.round((abs / 1_000_000) * 10) / 10;
  const mStr = m % 1 === 0 ? String(m.toFixed(0)) : String(m);

  return sign + mStr + "M";
};
